import { JSX } from "react";
import { Breadcrumbs } from "@hatch-digital-nl/bravilor-storybook";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { LanguageInterface } from "../../../common/interfaces/shared/LanguageInterface";
import { CartHeaderWidget } from "../../cartPage/components/CartHeaderWidget";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

interface Props {
    productName: string;
    hasData: boolean;
    isPageLoading: boolean;
    activeLanguage: LanguageInterface | null;
}

export const RefurbishedProductDetailsHeader = ({
    productName,
    hasData,
    isPageLoading,
    activeLanguage,
}: Props): JSX.Element => {
    const { t } = useStringTranslation();

    const renderBreadcrumbs = (): JSX.Element => {
        if (isPageLoading || !hasData || !activeLanguage) {
            return (
                <Breadcrumbs
                    isLoading
                    items={[]}
                    className="p-refurbished-product-details__breadcrumbs"
                />
            );
        }

        return (
            <Breadcrumbs
                className="p-refurbished-product-details__breadcrumbs"
                items={[
                    {
                        label: t("refurbished"),
                        to: RouteEnum.REFURBISHED,
                    },
                    {
                        label: productName,
                    },
                ]}
            />
        );
    };

    return (
        <div className="p-refurbished-product-details__header">
            {renderBreadcrumbs()}
            <CartHeaderWidget />
        </div>
    );
};
